"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeCameraRemoved", {
  enumerable: true,
  get: function get() {
    return _attendeeCameraRemoved["default"];
  }
});
var _attendeeCameraRemoved = _interopRequireDefault(require("./attendeeCameraRemoved"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }